import * as React from 'react'
import { cname } from '../utils'

/**
 * Card 组件封装
 *
 * - Card：卡片容器，含悬停阴影与边框高亮
 * - CardHeader：标题区（上下内边距）
 * - CardTitle：标题文本（加粗）
 * - CardDescription：描述区域（可自定义内容）
 * - CardContent：内容区
 * - CardFooter：底部操作区
 */
const Card = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cname(
      'relative rounded-md border border-transparent text-card-foreground hover:z-10 hover:border-[#EDF0F4] hover:shadow-[0_8px_16px_0px_rgba(40,47,84,0.15)]',
      className
    )}
    {...props}
  />
))
Card.displayName = 'Card'

const CardHeader = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cname('flex flex-col space-y-1.5 p-5 pb-4', className)} {...props} />
  )
)
CardHeader.displayName = 'CardHeader'

const CardTitle = React.forwardRef<HTMLParagraphElement, React.HTMLAttributes<HTMLHeadingElement>>(
  ({ className, ...props }, ref) => (
    <h3 ref={ref} className={cname('font-semibold tracking-tight', className)} {...props} />
  )
)
CardTitle.displayName = 'CardTitle'

const CardDescription = React.forwardRef<HTMLParagraphElement, React.HTMLAttributes<HTMLParagraphElement>>(
  // ({ className, ...props }, ref) => <p ref={ref} className={cname('', className)} {...props} />
  ({ className, ...props }, ref) => <div ref={ref} className={cname('', className)} {...props} />
)
CardDescription.displayName = 'CardDescription'

const CardContent = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => <div ref={ref} className={cname('p-5 pt-0', className)} {...props} />
)
CardContent.displayName = 'CardContent'

const CardFooter = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cname('flex items-center p-5 pb-4 pt-0', className)} {...props} />
  )
)
CardFooter.displayName = 'CardFooter'

export { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle }
